import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import boxLogo from '../assets/Box_Logo.png';

var ALLERGENS = [
  { key: 'gluten',       label: 'Gluten'      },
  { key: 'eggs',         label: 'Eggs'        },
  { key: 'fish',         label: 'Fish'        },
  { key: 'crustaceans',  label: 'Crustaceans' },
  { key: 'molluscs',     label: 'Molluscs'    },
  { key: 'milk_lactose', label: 'Lactose'     },
  { key: 'soy',          label: 'Soy'         },
  { key: 'peanuts',      label: 'Peanuts'     },
  { key: 'celery',       label: 'Celery'      },
  { key: 'mustard',      label: 'Mustard'     },
  { key: 'sesame',       label: 'Sesame'      },
  { key: 'sulphites',    label: 'Sulphites'   },
  { key: 'lupin',        label: 'Lupin'       },
  { key: 'almond',       label: 'Almond'      },
  { key: 'hazelnut',     label: 'Hazelnut'    },
  { key: 'walnut',       label: 'Walnut'      },
  { key: 'cashew',       label: 'Cashew'      },
  { key: 'pecan',        label: 'Pecan'       },
  { key: 'pistachio',    label: 'Pistachio'   },
  { key: 'brazil_nut',   label: 'Brazil Nut'  },
  { key: 'macadamia',    label: 'Macadamia'   },
  { key: 'pine_nut',     label: 'Pine Nut'    },
  { key: 'chestnut',     label: 'Chestnut'    },
  { key: 'hickory',      label: 'Hickory'     },
];

var navy        = '#445366';
var mid         = '#7A8A96';
var border      = '#D8DEE3';
var cream       = '#F7F6EF';
var white       = '#FFFFFF';
var charcoal    = '#2F3A42';
var red         = '#DC3545';
var redLight    = '#FFF0F0';
var amber       = '#E07B00';
var amberLight  = '#FFF3E0';
var skyText     = '#3A8FA3';
var skyLight    = '#EAF4F8';
var green       = '#7EA594';
var greenLight  = '#EAF2EF';
var olive       = '#6B7045';
var oliveLight  = '#F0F0E8';

function getAllergenStatus(value) {
  if (value === 'yes') return { label: 'Contains',       bg: redLight,   color: red,     border: red     };
  if (value === 'may') return { label: 'May contain',    bg: amberLight, color: amber,   border: amber   };
  if (value === 'sub') return { label: 'Can be subbed',  bg: skyLight,   color: skyText, border: skyText };
  if (value === 'rem') return { label: 'Can be removed', bg: oliveLight, color: olive,   border: olive   };
  return null;
}

function getDietaryBadge(dietary) {
  if (dietary === 'Vegan')             return { bg: greenLight, color: green,   label: 'Vegan'            };
  if (dietary === 'Vegetarian')        return { bg: skyLight,   color: skyText, label: 'Vegetarian'       };
  if (dietary === 'Vegan option')      return { bg: greenLight, color: green,   label: 'Can be Vegan'     };
  if (dietary === 'Vegetarian option') return { bg: skyLight,   color: skyText, label: 'Can be Vegetarian'};
  return null;
}

function allergenCount(dish) {
  return ALLERGENS.filter(function(a) {
    var v = dish[a.key];
    return v === 'yes' || v === 'may' || v === 'sub' || v === 'rem';
  }).length;
}

function DishRow(props) {
  var dish     = props.dish;
  var onClick  = props.onClick;
  var badge    = getDietaryBadge(dish.dietary);
  var count    = allergenCount(dish);

  return (
    <button onClick={onClick}
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.85rem 1rem', background: white, border: '1px solid ' + border, borderRadius: '12px', cursor: 'pointer', textAlign: 'left', width: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', flexWrap: 'wrap', flex: 1 }}>
        <span style={{ fontSize: '0.95rem', fontWeight: 600, color: charcoal }}>{dish.name}</span>
        {badge && (
          <span style={{ fontSize: '0.65rem', fontWeight: 600, padding: '0.12rem 0.55rem', borderRadius: '999px', background: badge.bg, color: badge.color, whiteSpace: 'nowrap' }}>
            {badge.label}
          </span>
        )}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', flexShrink: 0, marginLeft: '0.75rem' }}>
        <span style={{ fontSize: '0.72rem', color: count > 0 ? mid : green, fontWeight: count > 0 ? 400 : 600, whiteSpace: 'nowrap' }}>
          {count > 0 ? count + ' allergen' + (count !== 1 ? 's' : '') : 'None recorded'}
        </span>
        <span style={{ color: border, fontSize: '1rem' }}>{'>'}</span>
      </div>
    </button>
  );
}

function DishGroup(props) {
  var title   = props.title;
  var note    = props.note;
  var dishes  = props.dishes;
  var onClick = props.onClick;

  if (!dishes || dishes.length === 0) return null;

  return (
    <div style={{ marginBottom: '1.25rem' }}>
      <div style={{ marginBottom: '0.5rem' }}>
        <div style={{ fontSize: '0.78rem', fontWeight: 700, color: charcoal, marginBottom: note ? '0.2rem' : 0 }}>{title}</div>
        {note && <div style={{ fontSize: '0.72rem', color: mid, fontStyle: 'italic' }}>{note}</div>}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.45rem' }}>
        {dishes.map(function(dish) {
          return (
            <DishRow key={dish.id} dish={dish} onClick={function() { onClick(dish); }} />
          );
        })}
      </div>
    </div>
  );
}

function DishModal(props) {
  var dish    = props.dish;
  var onClose = props.onClose;

  var present = ALLERGENS.filter(function(a) {
    var v = dish[a.key];
    return v === 'yes' || v === 'may' || v === 'sub' || v === 'rem';
  });

  var badge = getDietaryBadge(dish.dietary);

  return (
    <div
      onClick={function(e) { if (e.target === e.currentTarget) onClose(); }}
      style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(47,58,66,0.6)', zIndex: 1000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}
    >
      <div style={{ background: white, borderRadius: '20px 20px 0 0', width: '100%', maxWidth: '560px', maxHeight: '88vh', overflowY: 'auto', padding: '1.5rem 1.25rem 2.5rem' }}>

        <div style={{ width: 40, height: 4, borderRadius: 2, background: border, margin: '0 auto 1.25rem' }}></div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
              <h2 style={{ margin: 0, fontSize: '1.15rem', fontWeight: 700, color: charcoal }}>{dish.name}</h2>
              {badge && (
                <span style={{ fontSize: '0.7rem', fontWeight: 600, padding: '0.15rem 0.6rem', borderRadius: '999px', background: badge.bg, color: badge.color }}>
                  {badge.label}
                </span>
              )}
            </div>
            <span style={{ fontSize: '0.75rem', color: mid, display: 'block', marginTop: '0.2rem' }}>{dish.menu} menu</span>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '1.3rem', color: mid, cursor: 'pointer', padding: '0.2rem 0.4rem', lineHeight: 1 }}>X</button>
        </div>

        {present.length === 0 ? (
          <div style={{ color: mid, fontSize: '0.9rem', padding: '1rem 0', textAlign: 'center' }}>No allergens recorded for this dish.</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.45rem', marginBottom: '1rem' }}>
            {present.map(function(a) {
              var status = getAllergenStatus(dish[a.key]);
              return (
                <div key={a.key} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.6rem 0.9rem', borderRadius: '10px', background: status.bg, border: '1px solid ' + status.border + '44' }}>
                  <span style={{ fontSize: '0.95rem', fontWeight: 600, color: charcoal, flex: 1 }}>{a.label}</span>
                  <span style={{ fontSize: '0.75rem', color: status.color, fontWeight: 600 }}>{status.label}</span>
                </div>
              );
            })}
          </div>
        )}

        {dish.notes ? (
          <div style={{ background: '#FEFCE8', border: '1px solid #F7EC71', borderRadius: '10px', padding: '0.7rem 0.9rem', marginBottom: '1rem' }}>
            <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#6B7045', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '0.25rem' }}>Notes</div>
            <div style={{ fontSize: '0.88rem', color: charcoal }}>{dish.notes}</div>
          </div>
        ) : null}

        <div style={{ background: navy, borderRadius: '10px', padding: '0.85rem', textAlign: 'center' }}>
          <p style={{ margin: 0, fontSize: '0.88rem', fontWeight: 700, color: white, lineHeight: 1.5 }}>
            Always inform our team of any allergies before ordering.
          </p>
        </div>
      </div>
    </div>
  );
}

export default function AllergensPublic() {
  var dishState        = useState([]);
  var dishes           = dishState[0];
  var setDishes        = dishState[1];

  var loadState        = useState(true);
  var loading          = loadState[0];
  var setLoading       = loadState[1];

  var searchState      = useState('');
  var search           = searchState[0];
  var setSearch        = searchState[1];

  var dietState        = useState('All');
  var dietaryFilter    = dietState[0];
  var setDietaryFilter = dietState[1];

  var menuState        = useState('Brunch');
  var menuFilter       = menuState[0];
  var setMenuFilter    = menuState[1];

  var modalState       = useState(null);
  var selectedDish     = modalState[0];
  var setSelectedDish  = modalState[1];

  useEffect(function() {
    supabase
      .from('allergen_list')
      .select('*')
      .eq('active', true)
      .order('name')
      .then(function(result) {
        if (!result.error && result.data) setDishes(result.data);
        setLoading(false);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var menus = [];
  dishes.forEach(function(d) {
    if (menus.indexOf(d.menu) === -1) menus.push(d.menu);
  });
  menus.sort();

  var baseFiltered = dishes.filter(function(d) {
    if (d.menu !== menuFilter) return false;
    if (search && d.name.toLowerCase().indexOf(search.toLowerCase()) === -1) return false;
    return true;
  });

  var isFiltered = dietaryFilter !== 'All';

  var exactDishes  = [];
  var optionDishes = [];
  var allDishes    = [];

  if (dietaryFilter === 'Vegetarian') {
    exactDishes  = baseFiltered.filter(function(d) { return d.dietary === 'Vegetarian' || d.dietary === 'Vegan'; });
    optionDishes = baseFiltered.filter(function(d) { return d.dietary === 'Vegetarian option' || d.dietary === 'Vegan option'; });
  } else if (dietaryFilter === 'Vegan') {
    exactDishes  = baseFiltered.filter(function(d) { return d.dietary === 'Vegan'; });
    optionDishes = baseFiltered.filter(function(d) { return d.dietary === 'Vegan option'; });
  } else if (dietaryFilter === 'Gluten Free') {
    exactDishes  = baseFiltered.filter(function(d) { return d.gluten === 'no'; });
    optionDishes = baseFiltered.filter(function(d) { return d.gluten === 'sub' || d.gluten === 'rem'; });
  } else {
    allDishes = baseFiltered;
  }

  var DIET_PILLS = ['All', 'Vegetarian', 'Vegan', 'Gluten Free'];

  return (
    <div style={{ minHeight: '100vh', background: cream, fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, sans-serif', margin: 0, padding: 0 }}>

      <div style={{ background: '#EAF4F8', borderBottom: '1px solid #BCD9E5', padding: '1rem 1.25rem' }}>
        <div style={{ maxWidth: '560px', margin: '0 auto', display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <img src={boxLogo} alt="Box Sociaal" style={{ width: 56, height: 56, objectFit: 'contain', flexShrink: 0 }} />
          <div>
            <h1 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 800, color: charcoal, letterSpacing: '-0.01em' }}>Allergen Information</h1>
            <p style={{ margin: '0.15rem 0 0', fontSize: '0.78rem', color: mid }}>Tap any dish to see full allergen details</p>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '560px', margin: '0 auto', padding: '1rem 1rem 4rem' }}>

        {menus.length > 1 && (
          <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.85rem', flexWrap: 'wrap' }}>
            {menus.map(function(m) {
              return (
                <button key={m} onClick={function() { setMenuFilter(m); }}
                  style={{ padding: '0.4rem 1rem', borderRadius: '999px', border: '2px solid ' + (menuFilter === m ? navy : border), background: menuFilter === m ? navy : white, color: menuFilter === m ? white : mid, fontSize: '0.85rem', fontWeight: menuFilter === m ? 700 : 400, cursor: 'pointer' }}>
                  {m}
                </button>
              );
            })}
          </div>
        )}

        <div style={{ marginBottom: '1.25rem' }}>
          <div style={{ fontSize: '0.7rem', fontWeight: 700, color: mid, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.5rem' }}>Dietary preference</div>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            {DIET_PILLS.map(function(pill) {
              var active = dietaryFilter === pill;
              var pillBg = active
                ? (pill === 'Vegetarian' ? skyText : pill === 'Vegan' ? green : pill === 'Gluten Free' ? '#E07B00' : navy)
                : white;
              var pillBorder = active
                ? (pill === 'Vegetarian' ? skyText : pill === 'Vegan' ? green : pill === 'Gluten Free' ? '#E07B00' : navy)
                : border;
              return (
                <button key={pill} onClick={function() { setDietaryFilter(pill); }}
                  style={{ padding: '0.32rem 0.85rem', borderRadius: '999px', border: '2px solid ' + pillBorder, background: pillBg, color: active ? white : mid, fontSize: '0.8rem', fontWeight: active ? 700 : 400, cursor: 'pointer' }}>
                  {pill}
                </button>
              );
            })}
          </div>
        </div>

        <input
          value={search}
          onChange={function(e) { setSearch(e.target.value); }}
          placeholder="Search dish..."
          style={{ width: '100%', padding: '0.65rem 1rem', border: '1.5px solid ' + border, borderRadius: '12px', fontSize: '0.95rem', color: charcoal, background: white, boxSizing: 'border-box', outline: 'none', marginBottom: '1.25rem' }}
        />

        <div style={{ display: 'flex', gap: '0.65rem', flexWrap: 'wrap', marginBottom: '1.25rem' }}>
          {[
            { bg: redLight,   color: red,     label: 'Contains'       },
            { bg: amberLight, color: amber,   label: 'May contain'    },
            { bg: skyLight,   color: skyText, label: 'Can be subbed'  },
            { bg: oliveLight, color: olive,   label: 'Can be removed' },
          ].map(function(item) {
            return (
              <div key={item.label} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                <div style={{ width: 14, height: 14, borderRadius: '50%', background: item.bg, border: '1.5px solid ' + item.color, flexShrink: 0 }}></div>
                <span style={{ fontSize: '0.72rem', color: mid }}>{item.label}</span>
              </div>
            );
          })}
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '3rem 0', color: mid }}>Loading...</div>
        ) : isFiltered ? (
          <div>
            <DishGroup
              title={dietaryFilter === 'Vegan' ? 'Vegan dishes' : dietaryFilter === 'Gluten Free' ? 'Gluten free dishes' : 'Vegetarian dishes'}
              dishes={exactDishes}
              onClick={function(d) { setSelectedDish(d); }}
            />
            <DishGroup
              title={'Can be made ' + dietaryFilter}
              note={dietaryFilter === 'Gluten Free' ? 'Gluten free options available - always inform your server. Our kitchen is not a gluten-free environment.' : 'These dishes can be adapted - let your server know when ordering.'}
              dishes={optionDishes}
              onClick={function(d) { setSelectedDish(d); }}
            />
            {exactDishes.length === 0 && optionDishes.length === 0 && (
              <div style={{ textAlign: 'center', padding: '2rem 0', color: mid, fontSize: '0.9rem' }}>No dishes found.</div>
            )}
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.45rem' }}>
            {allDishes.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '2rem 0', color: mid, fontSize: '0.9rem' }}>No dishes found.</div>
            ) : allDishes.map(function(dish) {
              return (
                <DishRow key={dish.id} dish={dish} onClick={function() { setSelectedDish(dish); }} />
              );
            })}
          </div>
        )}

        {!loading && (
          <div style={{ marginTop: '2rem', padding: '1rem', background: navy, borderRadius: '12px', textAlign: 'center' }}>
            <p style={{ margin: 0, fontSize: '0.92rem', fontWeight: 700, color: white, lineHeight: 1.5 }}>
              Always inform our team of any allergies before ordering.
            </p>
          </div>
        )}
      </div>

      {selectedDish && (
        <DishModal dish={selectedDish} onClose={function() { setSelectedDish(null); }} />
      )}
    </div>
  );
}